export default __webpack_public_path__ + "static/media/medical-room.07c78553.webp";